import Sider from "antd/es/layout/Sider";
import { useDispatch, useSelector } from "react-redux";
import { Menu, MenuProps } from "antd";
import { NavLink } from "react-router-dom";
import { RootState } from "../../../redux/store";
import { setOpenKeys, toggleSiderCollapse } from "../../../redux/reducer/antd-layout-info.reducer";
import { FormOutlined } from "@ant-design/icons";
import './cms-sider.css';
import { getImageUrl } from "../../../utils/image-helper/get-image-url";
import { RoleEnum } from "../../../features/users/enums/role.enum";

type MenuItem = Required<MenuProps>['items'][number];

export const CMSSider = () => {
    const dispatch = useDispatch();
    const { siderCollapsed, selectedMenuItemKeys, openKeys } = useSelector((state: RootState) => state.antdLayoutInfo);
    const user = useSelector((state: RootState) => state.session.user);
    const onOpenChange = (item: string[]) => {
        dispatch(setOpenKeys(item));
    };

    let items: MenuItem[] = [];
    
    if (user?.role === RoleEnum.Admin) {
        items = [
            {
                key: 'admin-dashboard',
                icon: <img src={getImageUrl( selectedMenuItemKeys.includes('admin-dashboard') ? 'active-dashboard-menu-icon.png' : 'inactive-dashboard-menu-icon.png')} alt="dashboard-menu-icon" />,
                label: <NavLink className='nav-link' to='/cms/admin/dashboard'>Főoldal</NavLink>,
                title: 'Főoldal'
            },
            {
                key: 'admin-companies',
                icon: <img src={getImageUrl( openKeys.includes('admin-companies') && ['admin-active-companies', 'admin-deleted-companies'].includes(selectedMenuItemKeys.length > 0 ? selectedMenuItemKeys[0] : '') ? 'active-company-menu-item.png' : 'inactive-company-menu-item.png')} alt="user-icon" />,
                label: 'Cégek',
                title: 'Cégek kezelése',
                children: [
                    {
                        key: 'admin-active-companies',
                        label: <NavLink className='nav-link' to='/cms/admin/active-companies'>Aktív cégek</NavLink>,
                        title: 'Aktív cégek kezelése'
                    },
                    {
                        key: 'admin-deleted-companies',
                        label: <NavLink className='nav-link' to='/cms/admin/deleted-companies'>Törölt cégek</NavLink>,
                        title: 'Törölt cégek kezelése'
                    }
                ]
            },
            {
                key: 'admin-users',
                icon: <img src={getImageUrl( selectedMenuItemKeys.includes('admin-users') ? 'user-icon-blue.png' : 'user-icon-black.png')} alt="user-icon" />,
                label: <NavLink className='nav-link' to='/cms/admin/users'>Felhasználók</NavLink>,
                title: 'Felhasználók kezelése'
            }
        ];
    } else if (user?.role === RoleEnum.CompanyAdmin) {
        items = [
            {
                key: 'company-admin-dashboard',
                icon: <img src={getImageUrl( selectedMenuItemKeys.includes('company-admin-dashboard') ? 'active-dashboard-menu-icon.png' : 'inactive-dashboard-menu-icon.png')} alt="dashboard-menu-icon" />,
                label: <NavLink className='nav-link' to='/cms/company-admin/dashboard'>Főoldal</NavLink>,
                title: 'Főoldal'
            },
            {
                key: 'company-admin-projects',
                icon: <FormOutlined />,
                label: <NavLink className='nav-link' to='/cms/company-admin/projects'>Projektek</NavLink>,
                title: 'Projektek kezelése'
            },
            {
                key: 'company-admin-users',
                icon: <img src={getImageUrl( selectedMenuItemKeys.includes('company-admin-users') ? 'user-icon-blue.png' : 'user-icon-black.png')} alt="user-icon" />,
                label: <NavLink className='nav-link' to='/cms/company-admin/users'>Felhasználók</NavLink>,
                title: 'Felhasználók kezelése'
            },
            {
                key: 'company-admin-files',
                icon: <img src={getImageUrl( selectedMenuItemKeys.includes('company-admin-files') ? 'files-icon-blue.png' : 'files-icon-black.png')} alt="files-icon" />,
                label: <NavLink className='nav-link' to='/cms/company-admin/files'>Fájlok</NavLink>,
                title: 'Fájlok kezelése'
            }
        ];
    } else if (user?.role === RoleEnum.Maintainer) {
        items = [
            {
                key: 'maintainer-dashboard',
                icon: <img src={getImageUrl( selectedMenuItemKeys.includes('maintainer-dashboard') ? 'active-dashboard-menu-icon.png' : 'inactive-dashboard-menu-icon.png')} alt="dashboard-menu-icon" />,
                label: <NavLink className='nav-link' to='/cms/maintainer/dashboard'>Főoldal</NavLink>,
                title: 'Főoldal'
            },
            
            {
                key: 'maintainer-users',
                icon: <img src={getImageUrl( selectedMenuItemKeys.includes('maintainer-users') ? 'user-icon-blue.png' : 'user-icon-black.png')} alt="user-icon" />,
                label: <NavLink className='nav-link' to='/cms/maintainer/users'>Felhasználók</NavLink>,
                title: 'Felhasználók kezelése'
            }
        ];
    }

    const handleMenuCollapseClick = () => {
        dispatch(toggleSiderCollapse());
    };

    return (
        <Sider className='cms-sider' collapsed={siderCollapsed} theme="light">
            
                <Menu
                    selectedKeys={selectedMenuItemKeys}
                    openKeys={openKeys}
                    onOpenChange={onOpenChange}
                    mode="inline"
                    theme="light"
                    items={items}
                />

                <div className="collapse-toggler-container">
                    <img src={getImageUrl('MenuFold.png')} alt="menu-fold" onClick={handleMenuCollapseClick} />
                </div>

        </Sider>
    )
}